import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ustayla_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("ustayla_token", token);
}
export function clearToken() {
  localStorage.removeItem("ustayla_token");
}

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function uploadFile(file, type = "portfolio") {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/upload?type=${encodeURIComponent(type)}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return `${BACKEND_URL}${data.url}`;
}

export function tl(n) {
  if (n == null) return "-";
  return new Intl.NumberFormat("tr-TR").format(n) + " TL";
}
